module.exports = __webpack_public_path__ + "static/media/check.846072af.svg";